import { ReactElement, useEffect, useRef } from 'react';
import { FeatureFlag, HeapCustomEvent, HeapEvent } from 'config';
import HeapAnalytics from 'services/HeapAnalytics';
import useCurrentUser from 'hooks/useCurrentUser';
import { useCart } from 'contexts/Cart';
import Modal from 'components/shared/Modal';
import Recipe from '../Recipes/Recipe';

type Props = {
  onClose: () => void,
};

function UpsellingModal({
  onClose,
}: Props): ReactElement {
  const { cart } = useCart();
  const { currentUser } = useCurrentUser();
  const { hasFavoritesEnabled } = currentUser;

  const {
    products,
    productsToUpsell,
    shippingPrice,
    hasNonSnackProductsToUpsell,
    shipping_fee: shippingFee,
  } = cart;

  const initialProductIds = useRef<number[]>(
    productsToUpsell.map((product) => product.productId),
  );

  const initialProductsToUpsell = initialProductIds.current.map((item) => (
    products.find((product) => product.items[0].sku.product_id === item)
  ));

  const initialUpsellingMealTypeSummary = useRef<string>(
    cart.newNonmaclatureUpsellingMealTypeSummary,
  );

  useEffect(() => {
    HeapAnalytics.track(HeapCustomEvent.EDIT_CART_UPSELL);
  }, []);

  const getModalHeaderText = () => {
    if (cart.hasFreeShipping) {
      return {
        title: 'Curated for you',
        subTitle: `We think you’ll love these ${hasNonSnackProductsToUpsell
          ? `tasty plant-based ${initialUpsellingMealTypeSummary.current}`
          : 'Grocery items'
        }. Add them to your order now.`,
      };
    }

    const freeShippingAmount = shippingFee.free_shipping_amount;

    return {
      title: `Save $${shippingPrice} When You Spend $${freeShippingAmount}!`,
      subTitle:
        `Add ${
          hasNonSnackProductsToUpsell
            ? 'items'
            : 'snacks'
        } to your order and unlock free shipping when you spend $${
          freeShippingAmount
        }.`,
    };
  };

  const headerText = getModalHeaderText();

  return (
    <Modal
      show
      onClose={onClose}
      className="c-plantry-upselling-modal"
      closeBtnClassName={HeapEvent.EDIT_CART_UPSELL_CLOSED}
      header={(
        <div className="c-plantry-upselling-modal__header">
          <Modal.Header>
            {headerText.title}
          </Modal.Header>
          <div>
            {headerText.subTitle}
          </div>
        </div>
      )}
      body={(
        <div className="c-form-group c-recipe-gallery">
          <div className="row">
            {initialProductsToUpsell.map((product) => (
              <Recipe
                  // @ts-expect-error TODO: fix null safety
                key={product.productId}
                  // @ts-expect-error TODO: fix null safety
                cartProduct={product}
                hasFavoritesEnabled={hasFavoritesEnabled}
                isUpsell
              />
            ))}
          </div>
        </div>
      )}
      footer={(
        <>
          <button
            type="button"
            className="c-button c-button--primary"
            onClick={onClose}
          >
            Continue
          </button>
        </>
      )}
    />
  );
}

export default UpsellingModal;
